
<template>
  <el-card>
    <template #header>
      <content-header/>
    </template>
    <el-form
      :model="dynamicValidateForm"
      ref="dynamicValidateForm"
      label-width="150px"
      class="demo-dynamic"
    >
      <el-card class="big-div">
        <p class="div-title">选择发送群体</p>
        <el-form-item
          prop="area_id"
          label="选择区域"
          :rules="[
            { required: true, message: '选择区域', trigger: 'blur' },
          ]"
        >
          <el-select class="limit-width" v-model="dynamicValidateForm.area_id" placeholder="请选择">
            <el-option
              v-for="item in areas"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="是否缴纳押金"
          prop="is_deposit"
          :rules="[
            { required: true, message: '缴纳押金', trigger: 'blur' },
          ]"
        >
          <el-radio v-model="dynamicValidateForm.is_deposit" label="1">已缴纳</el-radio>
          <el-radio v-model="dynamicValidateForm.is_deposit" label="0">未缴纳</el-radio>
        </el-form-item>
        <el-form-item
          label="是否实名"
          prop="is_card_certified"
          :rules="[
            { required: true, message: '是否实名', trigger: 'blur' },
          ]"
        >
          <el-radio v-model="dynamicValidateForm.is_card_certified" label="1">已实名</el-radio>
          <el-radio v-model="dynamicValidateForm.is_card_certified" label="0">未实名</el-radio>
        </el-form-item>
        <el-form-item
          label="是否高级筛选"
          prop="is_search"
          :rules="[
            { required: true, message: '是否高级筛选', trigger: 'blur' },
          ]"
        >
          <el-radio @change="gaoJiSearch" v-model="dynamicValidateForm.is_search" label="1">是</el-radio>
          <el-radio @change="gaoJiSearch" v-model="dynamicValidateForm.is_search" label="0">否</el-radio>
        </el-form-item>
        <el-form-item>
          <el-button v-show="isShowSearch" type="success" @click="Search">高级筛选</el-button>
        </el-form-item>
        <el-form-item>
          <p v-show="isShowSearch">已选择<span style="color:red;">{{ userNum }}</span> 个</p>
        </el-form-item>
      </el-card>
      <el-card class="big-div">
        <p class="div-title">短信模板以及内容</p>

        <el-form-item
          prop="template_id"
          label="模板ID"
          :rules="[
            { required: true, message: '请输入模板id', trigger: 'blur' },
          ]"
        >
          <el-select
            class="limit-width"
            v-model="dynamicValidateForm.template_id"
            @change="getDesc"
            placeholder="请选择"
          >
            <el-option
              v-for="item in templates"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
          <!-- <el-input class="limit-width" v-model="dynamicValidateForm.template_id"/> -->
        </el-form-item>
        <el-form-item label="短信内容">
          <el-input
            class="limit-width"
            type="textarea"
            disabled
            v-model="desc"
          />
        </el-form-item>
        <el-form-item
          v-for="(domain, index) in dynamicValidateForm.domains"
          :label="'参数' + (++index)"
          :key="domain.key"
          :prop="'domains.' + (--index) + '.value'"
          :rules="{
            required: true, message: '参数不能为空', trigger: 'blur'
          }"
        >
          <el-select
            class="limit-width"
            v-model="domain.value"
            filterable
            allow-create
            default-first-option
            placeholder="请填写参数"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button @click.prevent="removeDomain(domain)">删除</el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="addDomain">新增参数</el-button>
        </el-form-item>
      </el-card>

      <el-form-item>
        <el-button type="primary" @click="submitForm('dynamicValidateForm')">提交</el-button>
        <el-button @click="resetForm('dynamicValidateForm')">重置</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="用户筛选"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <el-table
        :data="users"
        :border="false"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="55"
          prop="id"
        />
        <el-table-column
          prop="id"
          label="ID"
          show-overflow-tooltip
          align="center"
          width="55"
        />
        <el-table-column
          prop="mobile"
          label="手机"
          width="180"
          align="right"
        />
      </el-table>
      <div class="card-footer">
        <pagination
          :page="page"
          @current-change="walletcurrentpage"
          @size-change="walletpagesize"
          :auto-push="false"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>
<script>
import { getAreas } from '@/api/area'
import { getUsers, groupSendSms, getGroupSmsTemplate } from '@/api/users'
import Pagination from '@c/Pagination'
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      dynamicValidateForm: {
        domains: [{
          value: '',
        }],
        area_id: '',
        is_deposit: '1',
        template_id: '',
        is_card_certified: '1',
        is_search: '0',
        ids: [],
      },
      areas: [],
      users: [],
      page: null,
      multipleSelection: [],
      options: [{
        value: 'now',
        label: '当前时间',
      }, {
        value: 'truename',
        label: '真实姓名',
      }],
      templates: [],
      desc: '',
      isShowSearch: false,
      dialogVisible: false,
      userNum: 0,
    }
  },
  async created() {
    const [
      { data: areas },
    ] = await Promise.all([
      getAreas({ all: 1 }),
    ])

    this.areas = areas
    const [
      { data: templates },
    ] = await Promise.all([
      getGroupSmsTemplate(),
    ])
    // templates.each(i => { this.templates.push({name:i.name,value:i.value}) })
    this.templates = templates
  },
  methods: {
    submitForm(formName) {
      if (this.dynamicValidateForm.is_search == '1') {
        if (this.dynamicValidateForm.ids.length == 0) {
          alert('请勾选高级搜索中要筛选发送的人')

          return
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
        //   console.log(this.dynamicValidateForm)
          groupSendSms(this.dynamicValidateForm).then(res => {
            res.then(data => {
              if (data) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                })
              }
            })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async gaoJiSearch() {
      let _this = this
      if (this.dynamicValidateForm.is_search == '1') {
        if (_this.dynamicValidateForm.area_id == '') {
          _this.dynamicValidateForm.is_search = '0'
          alert('请选择区域')
          return
        }
        this.isShowSearch = true
        // 筛选出用户
        const { data: { data, meta } } = await getUsers({ register_area_id: _this.dynamicValidateForm.area_id,
          is_deposit: _this.dynamicValidateForm.is_deposit,
          is_card_certified: _this.dynamicValidateForm.is_card_certified })
        this.users = data
        this.page = meta
      } else {
        this.isShowSearch = false
      }
    },
    async Search() {
      let _this = this
      _this.dialogVisible = true
      const { data: { data, meta } } = await getUsers({ register_area_id: _this.dynamicValidateForm.area_id,
        is_deposit: _this.dynamicValidateForm.is_deposit,
        is_card_certified: _this.dynamicValidateForm.is_card_certified })
      this.users = data
      this.page = meta
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    async walletcurrentpage(i) {
      let _this = this

      this.pagess.current_page = i
      const { data: { data, meta } } = await getUsers({ register_area_id: _this.dynamicValidateForm.area_id,
        is_deposit: _this.dynamicValidateForm.is_deposit,
        is_card_certified: _this.dynamicValidateForm.is_card_certified })
      this.users = data
      this.page = meta
    },
    async walletpagesize(i) {
      let _this = this

      this.pagess.page_size = i
      const { data: { data, meta } } = await getUsers({ register_area_id: _this.dynamicValidateForm.area_id,
        is_deposit: _this.dynamicValidateForm.is_deposit,
        is_card_certified: _this.dynamicValidateForm.is_card_certified })
      this.users = data
      this.page = meta
    },
    removeDomain(item) {
      var index = this.dynamicValidateForm.domains.indexOf(item)
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1)
      }
    },
    addDomain() {
      this.dynamicValidateForm.domains.push({
        value: '',
        key: Date.now(),
      })
    },
    handleSelectionChange(val) {
      // 多选改变时触发
      this.multipleSelection = val.map(i => i.id)
      this.dynamicValidateForm.ids = this.multipleSelection
      this.userNum = this.dynamicValidateForm.ids.length
      // console.log(this.dynamicValidateForm.ids)
    },
    getDesc(value) {
      this.templates.forEach((item, index) => {
        if (item.value === value) {
          this.desc = item.desc
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.big-div{
    // border:solid 1px #aaa;
    margin-left: 10px;
    margin-bottom: 10px;
    .div-title{
        color: #36a3f7;
        font-size: 1.2rem;
        margin-bottom: 10px;
        margin-top:10px;
    }
    .limit-width{
        width: 500px;
    }
}
</style>
